import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const importChargeDebtorTemplate = async ({
    token,
    formData,
}) => {

    try {
        const res = await axiosCreate.post('/charge/debtor/import', formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}